import { serverTimestamp } from 'firebase/firestore';
import type { User } from '@/lib/types/core';

/**
 * Single source of truth for default user profile fields.
 * Used by both useAuth (in-memory state) and UserProfileContext (Firestore doc creation).
 */
export function createDefaultUserProfile(fbUser: {
  uid: string;
  email?: string | null;
  displayName?: string | null;
  photoURL?: string | null;
}): Omit<User, 'created_at' | 'last_active'> & {
  created_at: ReturnType<typeof serverTimestamp>;
  updated_at: ReturnType<typeof serverTimestamp>;
  last_active: ReturnType<typeof serverTimestamp>;
} {
  return {
    id: fbUser.uid,
    name: fbUser.displayName ?? 'Unknown',
    email: fbUser.email ?? null,
    photo_url: fbUser.photoURL ?? null,
    custom_photo_url: null,
    telegram_username: null,
    telegram_id: null,
    beem_id: null,
    is_regular: true,
    is_active: true,
    entertainment_balance: 0,
    entertainment_unit_weight: 1.0,
    auto_approve_expenses: false,
    deactivated_at: null,
    entertainment_participant: false,
    entertainment_marked_at: null,
    entertainment_unmarked_at: null,
    entertainment_marked_by: null,
    entertainment_unmarked_by: null,
    hide_guests_on_leaderboard: false,
    pending_promotion: false,
    default_buyin_method: 'digital',
    default_payment_method: null,
    roles: {
      player: true,
      app_admin: false,
      entertainment_admin: false,
    },
    created_at: serverTimestamp(),
    updated_at: serverTimestamp(),
    last_active: serverTimestamp(),
  };
}
